import { API, Auth } from 'aws-amplify'

export type ApiResponse = {
  success: Boolean,
  message?: String
  name?: string,
  docNo?: string,
  docYear?: string
}

export const post = async(path: String, body: Object) => {
  const token = await (await Auth.currentSession()).getIdToken().getJwtToken()
  const myInit = { 
    body, 
    headers: {
      'Content-Type' : 'application/json',
      'Authorization': token
    }
  };
  const apiName = process.env.REACT_APP_REST_API_NAME;
  return await API.post(apiName, path, myInit)
}